import type { ComponentStyleConfig } from '@chakra-ui/theme';

const VStack: ComponentStyleConfig = {};

export default VStack;
